export default "__VITE_ASSET__$8WoTf$x__"